"use client";
import CustomButton from "@/components/common-components/CustomButton";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import "./index.css";
// import Category from "./categories/Category";
import Link from "next/link";
import { FootersocialIcons, usefulLinks } from "@/utlility/Constants";
import {
  FooterCross,
  FooterStar,
  LocationIcon,
  Mail,
  PhoneRing,
  TeethIcon,
} from "@/utlility/icons";
import { colors } from "@/app/Colors";
import dynamic from "next/dynamic";
const CustomModal = dynamic(() => import("@/components/common-components/CustomModal"), { ssr: false });
import { useSelector } from "react-redux";
// import { fetchCategories } from "@/redux/categoriesSlice";
import Image from "next/image";

import { fetchNavigationData } from "@/utlility/api-helpers";
export const Category = ({ title, content, inProp = null, marketArea = null }) => {
  return (
    <div className="d-flex flex-column gap-3  category-section">
      <h2 className="fw-semibold text-capitalize white-space-nowrap category-title">
        {title}
      </h2>
      <ul className="ps-0 pb-0 mb-0 d-flex flex-column category-content">
        {content?.map((item, i) => {
          return (
            <li key={i} className="d-flex align-items-center cursor-pointer">
              <Link
                href={
                  inProp
                    ? `${item?.category_slug}-in-${marketArea?.slug}`
                    : item?.category_slug
                }
                className="category-link d-flex align-items-center gap-2"
                aria-label={item?.category_name}
              >
                <TeethIcon color={colors["--white"]} size={12} />
                <span className="text-capitalize white-space-nowrap link-text">
                  {item?.category_name}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
const Footer = ({ initialLogo }) => {
  const [modalShow, setModalShow] = useState(false);
  const [marketArea, setMarketArea] = useState("");
  const [links, setLinks] = useState("");

  // const dispatch = useDispatch();

  const { featuresData: reduxFeaturesData, headerData } = useSelector((state) => state?.organization);
  const categoryData = reduxFeaturesData?.categories || [];

  useEffect(() => {
    const loadFooterData = async () => {
      // If we don't have featuresData in Redux, fetch it
      if (!reduxFeaturesData) {
        const navResult = await fetchNavigationData();

        if (navResult) {
          setLinks(navResult);
          const marketAreas = navResult.market_area;
          if (marketAreas) {
            const defaultArea = marketAreas.find((item) => item.is_default);
            setMarketArea(defaultArea);
          }
        }
      } else {
        // Use hydrated data from Redux
        setLinks(reduxFeaturesData);
        const marketAreas = reduxFeaturesData.market_area;
        if (marketAreas) {
          const defaultArea = marketAreas.find((item) => item.is_default);
          setMarketArea(defaultArea);
        }
      }
    };

    loadFooterData();
  }, [reduxFeaturesData]);

  const status = reduxFeaturesData ? "succeeded" : "loading";
  const error = null;

  if (status === "failed") {
    // Render the error message, or a fallback if it's not available
    return <p>Error: {error?.message || "Something went wrong"}</p>;
  }

  const linkData = (name) => {
    switch (name) {
      case "Facebook":
        return `${links?.facebook_link}`;
      case "Instagram":
        return `${links?.instagram_link}`;
      // case "Twitter":
      //   return `${headerData?.twitter_link}`;
      case "Youtube":
        return `${links?.youtube_link}`;
    }
  };

  return (
    <>
      <footer>
        <div className="get-appointment">
          <Container>
            <div className="grid align-items-center gap-4 gap-md-0">
              <h3 className="g-col-12 g-col-md-8 title fw-bold text-center text-md-start">
                Ready to get the smile you always deserved?
              </h3>
              <div className="g-col-12 g-col-md-4 d-flex justify-content-center justify-content-md-end">
                <CustomButton
                  text={"Get Appointment"}
                  onClick={() => setModalShow(true)}
                />
              </div>
            </div>
          </Container>
        </div>
        <div className="footer">
          <div className="background z-1">
            <Container>
              <div className="grid footer-content pb-4">
                <div className="g-col-12 g-col-lg-4">
                  <div className="left-content">
                    {initialLogo && typeof initialLogo === 'string' && (
                      <Image
                        src={initialLogo}
                        className="img-fluid logo"
                        alt="Site-Logo"
                        priority
                        width={127}
                        height={59}
                        title="Site-Logo"
                      />
                    )}
                    <p className="mt-4 description">
                      Regular dental checkups help in detection of early warning
                      signs of certain health related issues. Visit your
                      dentists regularly and stay healthy.
                    </p>
                    <div className="d-flex gap-2 mt-4">
                      {FootersocialIcons.map((item, i) => {
                        const url = linkData(item.name);
                        return (
                          <Link
                            key={i}
                            href={url}
                            target="_blank"
                            className="rounded-circle d-flex align-items-center justify-content-center position-relative overflow-hidden icon"
                            aria-label={item.name}
                          >
                            <i className="position-relative z-1 d-block">
                              {item.icon}
                            </i>
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="g-col-12 g-col-sm-6 g-col-md-3 g-col-lg-2">
                  <Category title="Useful Link" content={usefulLinks} />
                </div>
                {categoryData && (
                  <div className="g-col-12 g-col-sm-6 g-col-md-4 g-col-lg-3">
                    <Category
                      title="Services"
                      content={categoryData}
                      inProp={true}
                      marketArea={marketArea}
                    />
                  </div>
                )}

                <div className="g-col-12 g-col-md-5 g-col-lg-3">
                  <div className="d-flex flex-column gap-2 gap-md-4 contact-information">
                    <h2 className="fw-semibold text-capitalize category-title">
                      Contact Us
                    </h2>
                    <div className="d-flex flex-column gap-2 category-content">
                      {headerData?.location?.phone_number && (
                        <div className="d-flex align-items-center justify-content-start gap-3 item">
                          <i>
                            <PhoneRing color={colors["--primary"]} />
                          </i>
                          <Link
                            href={`tel:${headerData?.location?.phone_number}`}
                            target="_blank"
                          >
                            {headerData?.location?.phone_number}
                          </Link>
                        </div>
                      )}
                      {headerData?.location?.email && (
                        <div className="d-flex align-items-center justify-content-start gap-3">
                          <i>
                            <Mail color={colors["--primary"]} />
                          </i>
                          <Link
                            href={`mailto:${headerData?.location?.email}`}
                            target="_blank"
                          >
                            {headerData?.location?.email}
                          </Link>
                        </div>
                      )}
                      {headerData?.location?.map_location && (
                        <div className="d-flex align-items-start justify-content-start gap-3">
                          <i>
                            <LocationIcon color={colors["--primary"]} />
                          </i>
                          <address className="mb-0">
                            <Link
                              href={headerData?.location?.map_location}
                              target="_blank"
                            >
                              {headerData?.location?.address}
                            </Link>
                          </address>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="py-4 border-top footer-foot">
                <div className="grid align-items-center gap-2 gap-lg-4">
                  <p className="g-col-12 g-col-lg-4 sitename-foot text-center text-lg-start fw-medium">
                    © Ocean32 {new Date().getFullYear()} | All rights reserved
                  </p>
                  <div className="g-col-12 g-col-lg-8 text-center text-lg-end d-flex align-items-center justify-content-center justify-content-lg-end flex-wrap gap-2 ">
                    <Link href="/site-map" className="footer-foot-link ">
                      Sitemap
                    </Link>
                    |
                    <Link href="/target-region" className="footer-foot-link">
                      Target Region
                    </Link>{" "}
                    |
                    <Link href="/privacy-policy" className="footer-foot-link">
                      Privacy Policy
                    </Link>{" "}
                    |
                    <Link
                      href="/terms-and-condition"
                      className="footer-foot-link"
                    >
                      Terms & Conditions
                    </Link>
                  </div>
                </div>
              </div>
            </Container>

            {/* className={"position-absolute cross d-none d-sm-block z-n1 "}/> */}
            <FooterStar className="position-absolute big-star d-none d-sm-block z-n1 reverse-rotate" />
            <FooterStar className="position-absolute second-big-star d-none d-sm-block z-n1 travel" />
            <FooterStar size={57} className="position-absolute md-star d-none d-sm-block z-n1 twinkle-glow" />
            <FooterStar size={22} className="position-absolute sm-star d-none d-sm-block z-n1 star" />
            <FooterCross className="position-absolute cross d-none d-sm-block z-n1 moving-star " />
          </div>
        </div>
      </footer>

      <CustomModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default Footer;
